import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Divider, Typography } from '@mui/material';

import styles from './styles';

export interface LibAlertProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: JSX.Element | null;
}

export interface DialogTitleProps {
  title?: string;
  onClose: () => void;
}

function CustomizedDialogTitle(props: DialogTitleProps) {
  const { title, onClose, ...other } = props;

  return (
    <>
      <DialogTitle sx={styles.titleWrapper} {...{ component: 'div', ...other }}>
        <Typography variant="subtitle1" sx={styles.title}>
          {title}
        </Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={styles.closeIcon}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {title && <Divider sx={styles.divider} />}
    </>
  );
}

function LibDialog({ open, onClose, title, children }: LibAlertProps) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: styles.dialog
      }}
    >
      <CustomizedDialogTitle onClose={handleClose} title={title} />

      <DialogContent sx={{ padding: 1 }}>{children}</DialogContent>
    </Dialog>
  );
}

export const DialogAlert = React.memo(LibDialog);
